export default {
  FewerThan: 'Fewer than',
  TotalOutages: 'ACTIVE OUTAGES',
  TotalAffected: 'TOTAL CUSTOMERS AFFECTED',
  TotalServed: 'TOTAL CUSTOMERS SERVED',
  TotalRestored: 'TOTAL CUSTOMERS RESTORED',
  LessThan: 'Less than',
  LastUpdated: 'Last Updated: ',
  UpdateNotice: 'Information is updated approximately every 10 minutes.',
  ComEdUpdateNotice: 'Information is updated approximately every 15 minutes.'
};
